import { render, staticRenderFns } from "./reporteExamenesShow.vue?vue&type=template&id=01b460ac&"
import script from "./reporteExamenesShow.vue?vue&type=script&lang=js&"
export * from "./reporteExamenesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports